import type { ThreatKind } from './models';

export interface DifficultyValues {
  pressure: number;
  speedMultiplier: number;
  timingMultiplier: number;
  scoutErrorRadians: number;
  siegeErrorRadians: number;
  missileTurnRate: number;
}

export interface ThreatWeights {
  scout: number;
  missile: number;
  siege: number;
}

const radians = (degrees: number): number => (degrees * Math.PI) / 180;
const interpolate = (start: number, end: number, amount: number): number => start + (end - start) * amount;

export function difficultyForScore(score: number): DifficultyValues {
  const pressure = Math.max(0, Math.min(1, score / 100_000));
  return {
    pressure,
    speedMultiplier: 1 + 0.18 * pressure,
    timingMultiplier: 1 - 0.22 * pressure,
    scoutErrorRadians: radians(interpolate(8, 3, pressure)),
    siegeErrorRadians: radians(interpolate(4, 1.5, pressure)),
    missileTurnRate: radians(interpolate(45, 65, pressure)),
  };
}

export function weightsForScore(score: number): ThreatWeights {
  if (score < 8_000) return { scout: 1, missile: 0, siege: 0 };
  if (score < 20_000) return { scout: 0.58, missile: 0.42, siege: 0 };
  const pressure = Math.max(0, Math.min(1, (score - 20_000) / 80_000));
  return {
    scout: interpolate(0.34, 0.15, pressure),
    missile: interpolate(0.36, 0.34, pressure),
    siege: interpolate(0.3, 0.51, pressure),
  };
}

export function selectThreat(score: number, randomValue: number): ThreatKind {
  const weights = weightsForScore(score);
  const value = Math.max(0, Math.min(0.999_999, randomValue));
  if (value < weights.scout) return 'scout';
  if (value < weights.scout + weights.missile) return 'missile';
  return 'siege';
}
